const { createApp, h } = Vue
const rootEl = document.getElementById('productApp');
const apiImageComponent = {
    data() {
        return {
            apiImage: null,
            isApi: true,
            loading: false
        }
    },
    props: {
        item: Object,
        shopify: Object,
        startingImage: Number,
        images: Array
    },
    inject: ['height','hide','uploading','uploaded'],
    created() {
        if(this.item && this.item.hasOwnProperty('url')) {
            if(this.item.update === true) {
                if(sessionStorage.getItem('adobe-image-'+this.item.id)) {
                    this.$emit('downloadImage',sessionStorage.getItem('adobe-image-'+this.item.id));
                } else {
                this.loading = true
                let url = this.remoteApiUrl + 'shopify/api/download?id='+this.item.id;
                axios.get(url).then((response) => {
                    if(response.data && response.data.url) {
                            sessionStorage.setItem('adobe-image-'+this.item.id, response.data.url);
                            this.$emit('downloadImage', response.data.url);
                    }
                }).finally(() => {
                    this.loading = false;
                });
            }
            }
        } else {
            this.isApi = false
        }
    },
    emits: ['changeImage','downloadImage'],
    computed: {
        currentImage() {
            if(this.startingImage !== null
                && this.startingImage >= 0
                && this.startingImage < this.images.length) {
                return this.images[this.startingImage];
            }
        },
        imageClass() {
            return {
                'loading': this.loading || this.uploading,
                'custom-image-uploaded': this.uploaded,
            }
        },
        getImageUrl() {
            return this.isApi ? (this.item.upload ? this.item.upload : this.item.url) : this.shopify.featured_image
        },
    },
    methods: {
        nextImage() {
            let active = this.startingImage + 1;
            if(active >= this.images.length) {
                active = 0;
            }
            this.activateImage(active);
        },
        prevImage() {
            let active = this.startingImage - 1;
            if(active < 0) {
                active = this.images.length - 1;
            }
            this.activateImage(active);
        },
        activateImage(imageIndex) {
            this.$emit('changeImage', imageIndex);
        }
    },
    template: `<div class="product-image" :class="imageClass" :style="{ height: height }" v-if="item.custom">
        <img :src="getImageUrl" alt="" class="" id="product-image" v-show="!hide">
    </div>
    <template v-else>
        <div class="product-thumbs" id="thumbnails-wrapper">
            <ul class="slick-dots">
                <li :class="{'slick-active':index === this.startingImage}" v-for="(image, index) in images">
                    <a href="#" @click.prevent="activateImage(index)"><img :src="image.src"></a>
                </li>
            </ul>
        </div>
        <div class="product-main-img">
            <div class="gallery-wrapper slick-initialized slick-slider slick-dotted">
                <button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" @click.prevent="prevImage()">Previous</button>
                <div class="item">
                    <img class="img-responsive" alt="" :src="currentImage.src">
                </div>
                <button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" @click.prevent="nextImage()">Next</button>
            </div>
        </div>
    </template>
`,
}
const productApp = Vue.createApp({
    components: {
        'api-image': apiImageComponent,
        'api-similar-works': SimilarWorks,
        'wishlistlink': wishlistLink,
        'faqs': Faqs,
        // 'additional-info': AdditionalInfo
    },
    data() {
        return {
            items: [],
            item: null,
            shopify: {},
            sizes: {},
            productSizes: [],
            variant: null,
            instructionsOpen: false,
            shape: '1.5',
            tabs: {
                "shipping": {
                    "collapsed": true
                },
                "installation": {
                    "collapsed": true
                },
                "description": {
                    "collapsed": true
                }
            },
            cropperAdapter: null,
            productImage: null,
            imageWidth: 0,
            imageHeight: 0,
            imageRatio: 0,
            customSizes: {},
            sizesUpdated: 0,
            loading: false,
            loaded: false,
            errors: {},
            controller: null,
            files: null,
            croppedFiles: null,
            croppedPreview: null,
            copyright: true,
            imageContainerHeight: 0,
            imageHide: false,
            imageUploading: false,
            imageUploaded: false,
            downloadInterval: null,
            showActions: false,
            selectedImage: 0,
            cropCoordinates: {
                'imageWidth': 0,
                'imageHeight': 0,
                'left': 0,
                'top': 0,
                'croppedWidth': 0,
                'croppedHeight': 0,
                'flippedHorizontally': false,
            },
            discount: (this.partnerDiscount && window.customerIsPartner) ? this.partnerDiscount : this.autoDiscount
        }
    },
    props: ['type','shopifyType','autoDiscount','partnerDiscount'],
    provide() {
        return {
            height: Vue.computed(() => this.imageContainerHeight > 0 ? this.imageContainerHeight + 'px' : 'auto'),
            hide: Vue.computed(() => this.imageHide),
            uploading: Vue.computed(() => this.imageUploading),
            uploaded: Vue.computed(() => this.imageUploaded),
        }
    },
    created() {
        this.cartNotification = document.querySelector('cart-notification');
        this.getShopifyData()
        if(this.shopifyType === 'ShopifyCanvas') {
            this.getShopifyItem()
        } else {
            this.getItem()
        }
    },
    mounted () {
        this.observePdp();
        this.initProductImage();
    },
    computed: {
        price() {
            return (this.item && this.item.size) ? this.item.size.price : '';
        },
        specialPrice() {
            return (this.item && this.item.size) ? this.item.size.price * (1 - (Number(this.discount) / 100)) : '';
        },
        qty() {
            return 1;
        },
        images() {
            let imgs = []
            if(this.item && this.item.url && this.item.size) {
                if(this.shopifyType === 'ShopifyCanvas') {
                    if(this.shopify.hasOwnProperty('canvas_image') && this.shopify.canvas_image) {
                        imgs.push({'src': this.item.url});
                        this.canvasUrls[this.item.size.rendered_size].forEach((canvasUrl) => {
                            imgs.push({'src':canvasUrl + this.shopify.canvas_image});
                        })
                        imgs.push({'src':window.canvasImageBack});
                        imgs.push({'src':window.canvasImageSide});
                    } else {
                        this.shopify.images.forEach((image) => {
                            imgs.push({'src':image});
                        })
                    }
                } else {
                    imgs.push({'src':this.previewUrl + this.item.url});
                    this.canvasUrls[this.item.size.rendered_size].forEach((canvasUrl) => {
                        imgs.push({'src':canvasUrl + this.item.url});
                    })
                    imgs.push({'src':window.canvasImageBack});
                    imgs.push({'src':window.canvasImageSide});
                }
            }
            return imgs
        },
        cartLoading() {
            return store.getters['cartPopup/loading'];
        },
    },
    watch: {
        'item.variant': {
            handler(newValue, oldValue) {
                if(newValue) {
                    this.item.size = this.productSizes.find(size => size.id === newValue);
                }
            },
            deep: true
        },
        'item.options.bw': {
            handler(newValue, oldValue) {
                if(this.item.custom && this.imageUploaded && newValue !== null) {
                    if(newValue !== oldValue) {
                        this.bwImage();
                    }
                }
            },
            deep: true
        },
        'item.options.flip': {
            handler(newValue, oldValue) {
                if(this.item.custom && this.imageUploaded && newValue !== null) {
                    if(newValue !== oldValue) {
                        this.flipImage();
                    }
                }
            },
            deep: true
        },
        shape(newShape, oldShape) {
            this.item.ratio = newShape;
            this.updateSizes();
            if(this.item.custom && this.imageUploaded) {
                const eventD = new CustomEvent("destroyCropper");
                window.dispatchEvent(eventD);
                const eventU = new CustomEvent("customImageUploaded", {detail: { 'customRatio': newShape }});
                window.dispatchEvent(eventU);
            }
        }
    },
    methods: {
        initProductImage() {
            if(!this.downloadInterval) {
                this.downloadInterval = setInterval(() => {
                    if(document.getElementById('product-image')) {
                        clearInterval(this.downloadInterval);
                        this.productImage = document.getElementById('product-image');
                        this.cropperAdapter = new LimitlessCropper(jQuery(this.productImage));
                        if (this.productImage.complete && this.productImage.naturalWidth !== 0) {
                            this.imageWidth = this.productImage.naturalWidth;
                            this.imageHeight = this.productImage.naturalHeight;
                            this.imageRatio = this.imageWidth / this.imageHeight;
                        } else {
                            this.productImage.addEventListener('load', () => {
                                this.imageWidth = this.productImage.naturalWidth;
                                this.imageHeight = this.productImage.naturalHeight;
                                this.imageRatio = this.imageWidth / this.imageHeight;
                            });
                        }

                        window.addEventListener('destroyCropper', (event) => {
                            this.cropperAdapter.destroy();
                            this.resetCoordinates();
                            document.getElementById('cropped-image').value = '';
                            document.getElementById('image-preview-url').value = '';
                            this.croppedPreview = null;
                            this.croppedFiles = null;
                            this.loading = false;
                            this.imageUploading = false;
                            this.showActions = false;
                        });

                        window.addEventListener('initCropper', (event) => {
                            this.loading = true;
                            this.imageUploading = true;
                            //this.item.options.bw = false;
                            //this.item.options.flip = false;
                            setTimeout(() => {
                                this.cropperAdapter.init(event.detail,{'imageRatio':this.imageRatio, 'imageWidth':this.imageWidth, 'imageHeight':this.imageHeight});
                                this.loading = false;
                                this.imageUploading = false;
                                this.showActions = true;
                            }, 250);
                        });

                        window.addEventListener('replaceCropper', (event) => {
                            this.loading = true;
                            this.imageUploading = true;
                            setTimeout(() => {
                                this.cropperAdapter.replace(event.detail);
                                this.loading = false;
                                this.imageUploading = false;
                            }, 250)
                        });

                        window.addEventListener('customImageUploaded', (event) => {
                            this.sizesUpdated = 1;
                            this.customSizes = {'customRatio': this.item.ratio, 'customWidth': this.item.width, 'customHeight': this.item.height }
                            const eventI = new CustomEvent("initCropper", {detail: { 'customRatio': this.item.ratio }});
                            window.dispatchEvent(eventI);
                        });

                        this.productImage.addEventListener('cropper.created', (event) => {
                            this.loading = true;
                            this.imageUploading = true;
                            setTimeout(() => {
                                if(this.sizesUpdated === 1) {
                                    this.sizesUpdated = 0;
                                    this.cropperAdapter.updateForUserDimensions(this.customSizes);
                                }
                                if(this.item.options.flip) {
                                    this.cropperAdapter.flip();
                                }
                                this.loading = false;
                                this.imageUploading = false;
                            }, 500)
                        });

                        this.productImage.addEventListener('image.updated', (event) => {
                            this.loading = true;
                            this.imageUploading = true;
                            setTimeout(() => {
                                const imageData = this.cropperAdapter.getImageData();
                                if(imageData) {
                                    document.getElementById('cropped-image').value = imageData.toDataURL('image/jpeg');
                                    this.generatePreview(false);
                                    this.generateCroppedImage(imageData).finally(() => {
                                        this.loading = false;
                                        this.imageUploading = false;
                                        const cropperData = this.cropperAdapter.getData();
                                        this.cropCoordinates = {
                                            'imageWidth': this.imageWidth,
                                            'imageHeight': this.imageHeight,
                                            'left': Math.round(cropperData.x),
                                            'top': Math.round(cropperData.y),
                                            'croppedWidth': Math.round(cropperData.width),
                                            'croppedHeight': Math.round(cropperData.height),
                                            'flippedHorizontally': cropperData.scaleX == -1 ? true : false,
                                        }
                                    })
                                } else {
                                    this.loading = false;
                                    this.imageUploading = false;
                                }
                            }, 750)
                        });

                        this.productImage.addEventListener('image.cropping',(event) => {
                            /*
                            setTimeout(() => {
                                this.loading = true;
                                this.imageUploading = true;
                            }, 50)

                             */
                        });
                    }
                },500);
            }
        },
        resetCoordinates() {
            this.cropCoordinates = {
                'imageWidth': 0,
                'imageHeight': 0,
                'left': 0,
                'top': 0,
                'croppedWidth': 0,
                'croppedHeight': 0,
                'flippedHorizontally': false,
            }
        },
        generateCroppedImage(imageData) {
            return new Promise((resolve, reject) => {
                const fileName = Math.random().toString(36).slice(2) + '.png';
                imageData.toBlob((blob) => {
                    this.croppedFiles = new File([blob], fileName, { type: "image/png" });
                    resolve();
                }, 'image/png')
            })
        },
        generatePreview(showPopup) {
            let imagePreview = document.getElementById('image-preview-url');
            let imgData = document.getElementById('cropped-image').value;
            if(imgData !== '') {
                this.loading = true;
                this.imageUploading = true;
                const url = 'https://40reag6pmj.execute-api.us-east-1.amazonaws.com/Prod/limitless/';
                const params = new URLSearchParams();
                params.append('frame','canvas2');
                params.append('style','style1');
                params.append('url',imgData);
                params.append('response','json');
                params.append('name',Date.now().toString());
                if (this.controller !== null) {
                    this.controller.abort();
                }
                this.controller = new AbortController();
                axios.post(url, params, {signal: this.controller.signal})
                    .then((response) => {
                        if(response.data && response.data.location) {
                            if(showPopup) {
                                let image = new Image();
                                image.onload = (imageEvent) => {
                                    const imageClass = this.item.options.bw ? 'desaturate': '';
                                    const modalBody =`<div class="image ${imageClass}"><img src="${response.data.location}" alt=""></div>`;
                                    store.dispatch('modal/set', {
                                        'modalClass': 'image-preview-popup',
                                        'modalBody': modalBody
                                    })
                                    this.openModal();
                                }
                                image.src = response.data.location;
                            }
                            this.croppedPreview = response.data.location;
                            imagePreview.value = response.data.location;
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    }).finally(() => {
                        this.loading = false;
                        this.imageUploading = false;
                    });
            }
        },
        onUpload(e) {
            this.files = e.target.files || e.dataTransfer.files;
            this.imagePreview();
        },
        imagePreview() {
            const resizer = window.pica();
            const supportedFormats = ['image/jpeg','image/jpg','image/gif','image/png','application/pdf'];
            const imageFormats = ['image/jpeg','image/jpg','image/gif','image/png'];
            const maxSize = 20971520; // 20Mb
            if (this.files && this.files[0]) {
                const uploaded = this.files[0];
                if(!supportedFormats.includes(uploaded.type)) {
                    alert('This online uploader only accepts png, gif, and jpeg files. Please contact info@limitlesswalls.com for assistance with any other file types.');
                    return false;
                }
                if(uploaded.size > maxSize) {
                    alert('File size exceeds our 20mb max. Please send file via email to info@limitlesswalls.com.');
                    return false;
                }
                if(imageFormats.includes(uploaded.type)) {
                    const productImage = document.getElementById('product-image');
                    const reader = new FileReader();
                    this.imageContainerHeight = productImage.naturalHeight;
                    this.imageHide = true;
                    this.imageUploading = true;
                    reader.addEventListener('load', (readerEvent) => {
                        let image = new Image();
                        let ratio = 1;
                        image.onload = (imageEvent) => {
                            this.item.options.bw = false;
                            this.item.options.flip = false;
                            // Resize the image
                            var canvas = document.createElement('canvas'),
                                max_size = 1200,
                                width = image.width,
                                height = image.height;
                            if (width > height) {
                                if (width > max_size) {
                                    height *= max_size / width;
                                    width = max_size;
                                }
                            } else {
                                if (height > max_size) {
                                    width *= max_size / height;
                                    height = max_size;
                                }
                            }
                            canvas.width = width;
                            canvas.height = height;
                            this.item.width = width;
                            this.item.height = height;
                            this.imageWidth = width;
                            this.imageHeight = height;
                            this.imageRatio = ratio;
                            resizer.resize(image, canvas)
                                .then(() => {
                                    ratio = Math.round(width/height*100)/100;
                                    this.item.upload = canvas.toDataURL('image/jpeg');
                                    document.getElementById('cropped-image').value = this.item.upload;
                                }).then(() => {
                                    return this.generateCroppedImage(canvas)
                                }).finally(() => {
                                    this.imageUploading = false;
                                    this.imageHide = false;
                                    this.imageContainerHeight = 0;
                                    this.imageUploaded = true;
                                    const eventD = new CustomEvent("destroyCropper");
                                    window.dispatchEvent(eventD);
                                    const eventU = new CustomEvent("customImageUploaded", {detail: { 'customRatio': ratio }});
                                    window.dispatchEvent(eventU);
                                });
                        }
                        image.src = readerEvent.target.result;
                    });
                    reader.readAsDataURL(this.files[0]);
                }

            }
        },
        openUploadTips() {
            const modalBody =`<h3>Browse For Your Image</h3>
                    <p>We will accept the following file types for online orders: .jpg, .png, .bmp.</p>
                    <p>We also can use .psd, .psb, .eps, .ai, .tiff, or .pdf files. Please <a href="/pages/contact" target="_blank">contact us</a> or call us at 888-722-3674 for instructions to send your files.</p>
                    <p>Please call us at 888-722-3674 or <a href="/pages/contact" target="_blank">contact us</a> for assistance with other files types.</p>`;
            store.dispatch('modal/set', {
                'modalClass': 'modal-tips',
                'modalBody': modalBody
            })
            this.openModal();
        },
        openModal() {
            store.dispatch('modal/open')
        },
        closeModal() {
            store.dispatch('modal/close')
        },
        changeImage(index) {
            this.selectedImage = index;
        },
        downloadImage(image) {
            this.item.url = image;
        },
        bwImage() {
            setTimeout(() => {
                let images = document.querySelectorAll('.product-img img');
                if(this.item.options.bw === false) {
                    images.forEach((image) => {
                        image.classList.remove('desaturate');
                    })
                } else {
                    images.forEach((image) => {
                        image.classList.add('desaturate');
                    })
                }
            },250);
        },
        flipImage() {
            if(this.cropperAdapter && this.cropperAdapter.isBuilt) {
                const originalData = this.cropperAdapter.getData();
                const cropBox = document.querySelector('.cropper-crop-box');
                let topPos = originalData.y;
                let leftPos = originalData.x;
                let width = 0;
                let height = 0;
                if(cropBox) {
                    topPos = cropBox.style.top;
                    leftPos = cropBox.style.left;
                    width = cropBox.style.width;
                    height = cropBox.style.height;
                }
                if(this.item.options.flip === false) {
                    this.cropperAdapter.unflip();
                } else {
                    this.cropperAdapter.flip();
                }
                this.customSizes.x = leftPos;
                this.customSizes.y = topPos;
                if(width && height) {
                    this.customSizes.flipWidth = width;
                    this.customSizes.flipHeight = height;
                }
                this.cropperAdapter.updateForUserDimensions(this.customSizes);
                const event = new CustomEvent("image.updated");
                this.productImage.dispatchEvent(event);
            }
            setTimeout(() => {
                if(this.item.options.flip === false) {
                    this.productImage.classList.remove('mirror');
                } else {
                    this.productImage.classList.add('mirror');
                }
            },250);
        },
        getShopifyData() {
            try {
                this.shopify = JSON.parse(document.getElementById('product-json').textContent);
                this.sizes = JSON.parse(document.getElementById('product-sizes-json').textContent);
            } catch (e) {
                console.error(e)
            }
        },
        variantPrice(price) {
            return price * (1 - (Number(this.discount) / 100));
        },
        getShopifyItem() {
            const img = new Image();
            img.onload = () => {
                const width = img.width
                const height = img.height
                this.item = {
                    "sku": this.shopify.sku,
                    "id": this.shopify.id,
                    "item_number": this.shopify.item_number,
                    "handle": this.shopify.handle,
                    "url": this.shopify.featured_image,
                    "url_key": this.shopify.handle,
                    "title": this.shopify.title,
                    "meta_title": this.shopify.title,
                    "meta_description": this.shopify.description,
                    "description": this.shopify.description,
                    "update": false,
                    "type": this.type,
                    "width": width,
                    "height": height,
                    "ratio": this.shopify.aspect_ratio,
                    "size": null,
                    "variant": null,
                    "shopify": true,
                    "instructions": '',
                    "options": {}
                }
                this.updateMetas(this.item);
                this.updateSizes();
                this.loaded = true;
            }
            img.src = this.shopify.featured_image
        },
        getItem() {
            let image = null
            let title = 'Canvas Print'
            let categoryName = null
            let updateImage = false
            let imageId = null
            let urlKey = null
            let productId = null
            const params = new URLSearchParams(window.location.search);
            const url = new URL(window.location);
            if(params.has('imageId') === true) {
                imageId = parseInt(params.get('imageId'))
            } else {
                let urlId = url.pathname.replace('/products/canvas/','');
                if(/^\d+$/.test(urlId)) {
                    imageId = parseInt(urlId);
                } else {
                    urlKey = urlId;
                    if(urlKey.indexOf('_') >= 0) {
                        let splitUrlKey = urlKey.split('_');
                        urlKey = splitUrlKey[0];
                        if(/^\d+$/.test(splitUrlKey[1])) {
                            productId = parseInt(splitUrlKey[1]);
                        }
                    }
                }
            }
            if(params.has('updateImage') === true) {
                updateImage = true
            }
            if(params.has('image') === true) {
                try {
                    image = atob(params.get('image'))
                } catch (e) {
                    console.error(e);
                }
            }
            if(params.has('title') === true) {
                try {
                    title = this.capitalize(atob(params.get('title')))
                    title = title.replace(/\./g, ' ');
                    if(title.indexOf('Canvas Print') === -1) {
                        title = title + ' Canvas Print';
                    }
                } catch (e) {
                    console.error(e);
                }
            }
            if(params.has('category') === true) {
                try {
                    categoryName = this.capitalize(atob(params.get('category')))
                    categoryName = categoryName.replace(/\./g, ' ');
                } catch (e) {
                    console.error(e);
                }
            }

            // API product
            if(image) {
                this.validateStopWords({title: title},true)
                    .then((response) => {
                        if(!response) {
                            window.location.href = '/not-found';
                            return false;
                        } else {
                            return response;
                        }
                    }).then((response) => {
                        if(response) {
                            const img = new Image();
                            img.onload = () => {
                                const width = img.width
                                const height = img.height
                                const imageRatio = this.getAspectRatio(width, height)
                                this.item = {
                                    "id": imageId,
                                    "url": image,
                                    "title": title,
                                    "categories": categoryName ? [{'name': categoryName}] : [],
                                    "update": updateImage,
                                    "type": this.type,
                                    "width": width,
                                    "height": height,
                                    "ratio": imageRatio,
                                    "size": null,
                                    "variant": null,
                                    "instructions": '',
                                    "options": {}
                                }
                                this.fetchCategory();
                                this.updateMetas(this.item);
                                this.updateSizes();
                                this.loaded = true;
                            }
                            img.src = image
                        }
                    });
            // Magento Product
            } else if(urlKey) {
                // Custom Uploader
                if(urlKey === 'custom') {
                    const img = new Image();
                    img.onload = () => {
                        const width = img.width
                        const height = img.height
                        const imageRatio = this.getAspectRatio(width, height)
                        this.item = {
                            "custom": true,
                            "id": null,
                            "url": window.previewImageUrl,
                            "url_key": urlKey,
                            "categories": [{'name':'Custom Image'}],
                            "title": 'Create Your Own Canvas Print',
                            "meta_title": 'Create Your Own Canvas Print',
                            "meta_description": 'This product is used to manage customized image upload product configuration',
                            "description": 'Create Your Own Canvas Print',
                            "update": false,
                            "type": this.type,
                            "width": width,
                            "height": height,
                            "ratio": imageRatio,
                            "upload": window.previewImageUrl,
                            "size": null,
                            "variant": null,
                            "instructions": '',
                            "options": {
                                "bw": false,
                                "flip": false
                            }
                        }
                        this.updateMetas(this.item);
                        this.updateSizes();
                        this.loaded = true;
                    }
                    img.src = window.previewImageUrl;
                } else {
                    // Magento Product
                    let url = this.remoteApiUrl + 'shopify/api/load?isAjax=1&type=canvas&url='+urlKey;
                    if(productId) {
                        url += '&entity_id=' + productId;
                    }
                    axios.get(url)
                        .then((response) => {
                            if(response.data && response.data.product) {
                                const test = response.data.product;
                                return this.validateStopWords(test,response);
                            } else {
                                return response;
                            }
                        })
                        .then((response) => {
                            if(!response || !response.data || !response.data.product) {
                                window.location.href = '/not-found';
                                return false;
                            } else {
                                return response;
                            }
                        })
                        .then((response) => {
                            if(response && response.data && response.data.product) {
                                const product = response.data.product;
                                if(product.hasOwnProperty('type') && product['type'] !== 'canvas') {
                                    // redirect to correct typy
                                    window.location.href = '/products/'+product['type']+'/'+product['url'];
                                    return false;
                                }
                                const img = new Image();
                                img.onload = () => {
                                    const width = img.width
                                    const height = img.height
                                    const imageRatio = this.getAspectRatio(width, height)
                                    this.item = {
                                        "entity_id": product.entity_id,
                                        "sku": product.sku,
                                        "similar_categories": product.similar_categories,
                                        "categories": product.similar_categories,
                                        "id": product.id,
                                        "url": product.thumbnail_url,
                                        "url_key": productId ? urlKey+'_'+productId : urlKey,
                                        "title": product.title,
                                        "meta_title": product.meta_title,
                                        "meta_description": product.meta_description,
                                        "additional_info": product.additional_info,
                                        "description": product.description,
                                        "update": false,
                                        "type": this.type,
                                        "width": width,
                                        "height": height,
                                        "ratio": imageRatio,
                                        "size": null,
                                        "variant": null,
                                        "instructions": '',
                                        "options": {}
                                    }
                                    this.updateMetas(this.item);
                                    this.updateSizes();
                                    this.loaded = true;
                                }
                                img.src = product.thumbnail_url
                            } else {
                                window.location.href = '/products/canvas/custom';
                                return false;
                            }
                        }).finally(() => {

                        });
                }
            // API Product with Image ID only
            } else if(imageId) {
                let url = this.remoteApiUrl + 'shopify/api/get?isAjax=1&type=canvas&id='+imageId;
                axios.get(url)
                    .then((response) => {
                        if(response.data && response.data.product) {
                            const test = response.data.product;
                            return this.validateStopWords(test,response);
                        } else {
                            return response;
                        }
                    })
                    .then((response) => {
                        if(!response || !response.data || !response.data.product) {
                            window.location.href = '/not-found';
                            return false;
                        } else {
                            return response;
                        }
                    }).then((response) => {
                        if(response && response.data && response.data.product) {
                            const product = response.data.product;
                            const img = new Image();
                            img.onload = () => {
                                const width = img.width
                                const height = img.height
                                const imageRatio = this.getAspectRatio(width, height)
                                this.item = {
                                    "id": product.id,
                                    "url": product.thumbnail_url,
                                    "title": product.title,
                                    "categories": product.hasOwnProperty('category') && product.category ? product.category : [],
                                    "update": false,
                                    "type": this.type,
                                    "width": width,
                                    "height": height,
                                    "ratio": imageRatio,
                                    "size": null,
                                    "variant": null,
                                    "instructions": '',
                                    "options": {}
                                }
                                this.updateMetas(this.item);
                                this.updateSizes();
                                this.loaded = true;
                            }
                            img.src = product.thumbnail_url
                        }
                    }).catch((error) => {
                        let filters = this.cloneObject(this.xApiFilters);
                        filters['search_parameters']['thumbnail_size'] = 1000;
                        filters['search_parameters']['media_id'] = imageId;
                        fetch(this.adobeApiSearchUrl, {method: 'POST', body: JSON.stringify(filters), headers: this.fetchHeaders})
                            .then((response) => response.json())
                            .then((response) => {
                                if(response && response.files && response.files.length > 0) {
                                    const product = response.files[0];
                                    const img = new Image();
                                    img.onload = () => {
                                        const width = img.width
                                        const height = img.height
                                        const imageRatio = width / height
                                        this.item = {
                                            "id": product.id,
                                            "url": product.thumbnail_url,
                                            "title": product.title,
                                            "categories": [],
                                            "update": false,
                                            "type": this.type,
                                            "width": width,
                                            "height": height,
                                            "ratio": imageRatio,
                                            "size": null,
                                            "variant": null,
                                            "instructions": '',
                                            "options": {}
                                        }
                                        this.updateMetas(this.item);
                                        this.updateSizes();
                                        this.loaded = true;
                                    }
                                    img.src = product.thumbnail_url
                                }
                            })
                    }).finally(() => {

                    });
            }
        },
        fetchCategory() {
            if(this.item && this.item.hasOwnProperty('id') && this.item.id) {
                fetch(this.adobeApiMetadataUrl, {method: 'POST', body: JSON.stringify({'id': this.item.id}), headers: this.fetchHeaders})
                    .then((response) => response.json())
                    .then((response) => {
                        if(response && response.hasOwnProperty('files') && response['files'] && response['files'].length > 0) {
                            response['files'].forEach((resultFile) => {
                                if(resultFile.hasOwnProperty('id') &&
                                    resultFile.id === this.item.id &&
                                    resultFile.hasOwnProperty('category') &&
                                    resultFile['category'] &&
                                    resultFile['category'].hasOwnProperty('name'))
                                {
                                    this.item.categories.push(resultFile['category']);
                                }
                            })
                        }
                    })
                    .catch((error) => console.error(error));
            }

        },
        updateSizes() {
            this.productSizes = this.sizes.filter(size => (size.aspect_ratio === this.item.ratio));
            this.item.variant = this.productSizes[0].id;
            this.item.size = this.productSizes[0];
        },
        canvasSize() {
            const size = this.sizes.find(size => {
                if(this.item.ratio === '3') {
                    return (
                        size.rendered_size === 'medium' &&
                        size.aspect_ratio === this.item.ratio
                    )
                } else {
                    return (
                        size.rendered_size === 'small' &&
                        size.aspect_ratio === this.item.ratio
                    )
                }
            })
            return size;
        },
        getImageUrl() {
            return this.item? this.item.url : ''
        },
        addToCart() {
            this.errors = {};

            let properties = {
                '_id': this.item.custom ? 'custom' : this.item.id,
                '_entity_id': this.item.hasOwnProperty('entity_id') && this.item.entity_id ? this.item.entity_id : null,
                '_sku': this.item.hasOwnProperty('sku') && this.item.sku ? this.item.sku : this.item.custom ? 'custom' : this.item.id,
                '_canvas_image': this.shopifyType === 'ShopifyCanvas' ? this.item.url : this.previewUrl + this.item.url,
                '_cropped_image': document.getElementById('cropped-image').value,
                '_original_image': this.item.url,
                '_product_url': window.location.href.split('?')[0],
                '_url_key': this.item.hasOwnProperty('url_key') && this.item.url_key ? this.item.url_key : null,
                '_name': this.item.title,
                '_quantity': 1,
                '_type': this.type,
                '_bw': false,
                '_flip': false,
                '_coordinates': JSON.stringify(this.cropCoordinates),
                'Size': this.decodeEntity(this.item.size.size)
            };

            let options = [];
            if(this.item.options.bw && this.item.options.bw !== '') {
                properties['_bw'] = true;
                options.push(this.item.options.bw);
            };
            if(this.item.options.flip && this.item.options.flip !== '') {
                properties['_flip'] = true;
                options.push(this.item.options.flip);
            };
            if(options.length > 0) {
                properties['Options'] = options.join(', ');
            }
            if(this.item.instructions && this.item.instructions !== '') {
                properties['Comments'] = this.item.instructions;
            }
            if(this.files && this.files[0]) {
                properties['_uploaded_image'] = this.files[0];
            }
            if(this.croppedFiles) {
                properties['_cropped_image'] = this.croppedFiles;
            }

            const data = {
                items: [{
                    id: this.item.variant,
                    quantity: 1,
                    properties: properties
                }],
                'sections': this.cartNotification.getSectionsToRender().map((section) => section.id),
                'sections_url': window.location.pathname
            };
            const additionalData = {
                specialPrice: this.specialPrice,
                correctedPrice: this.price,
                productUrl: window.location.pathname.split('?')[0],
                size: properties['Size'],
                area: null,
                weight: this.item.size.weight,
                image: properties['_canvas_image']
            }
            const formData = new FormData();
            formData.set('id',this.item.variant);
            formData.set('quantity',1);

            for(const key in properties) {
                formData.set(`properties[${key}]`,properties[key]);
            }

            const submitData = new FormData();
            submitData.set('id',properties['_id']);
            submitData.set('sku',properties['_sku']);
            submitData.set('type',this.item.type);
            submitData.set('title',this.item.title);
            submitData.set('size',additionalData['size']);
            submitData.set('correctedPrice',additionalData['correctedPrice']);
            submitData.set('weight',additionalData['weight']);
            submitData.set('image',additionalData['image']);
            if(this.croppedPreview) {
                submitData.set('preview',this.croppedPreview);
            }
            if(this.item.categories && this.item.categories.length > 0) {
                const categoryNames = this.item.categories.map(category => category.name);
                const uniqueCategoryNames = [...new Set(categoryNames)];
                submitData.set('tags',uniqueCategoryNames.join(','));
            }

            if(this.shopifyType === 'ShopifyCanvas') {
                store.dispatch('cartPopup/order', {
                    'cart': data,
                    'form': formData,
                    'product': this.shopify,
                    'sections': this.cartNotification.getSectionsToRender().map((section) => section.id),
                    'sections_url': window.location.pathname
                });
            } else {
                store.dispatch('cartPopup/submit', {
                    'cart': data,
                    'form': formData,
                    'product': this.item,
                    'additional': submitData,
                    'sections': this.cartNotification.getSectionsToRender().map((section) => section.id),
                    'sections_url': window.location.pathname
                });
            }

            const productUrl = window.location.href.split('?')[0];
            const productData = {
                'pageType' : 'Add to Cart',
                'event'    : 'Add to Cart',
                'products': [{
                    'id': this.item.id,
                    'sku': this.item.id,
                    'productType': this.item.type,
                    'name': this.item.title,
                    'price': document.getElementById('hidden_product_price').value,
                    'imageURL': this.item.url,
                    'productURL': productUrl
                }]
            };
            this.updateDataLayer(productData);
        }
    },
}, { ...rootEl.dataset })
const faqsApp = Vue.createApp({
    components: {
        'faqs': Faqs,
    }
});
productApp.use(AdobeClientPlugin).use(store);
productApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('api') && !tag.includes('additional-info')
productApp.config.unwrapInjectedRef = true
document.addEventListener('DOMContentLoaded', function () {
    productApp.mount('#productApp');
    faqsApp.mount('#faqsApp');
});
